import axiosInstance from "../axiosConfig";

export const getAllCustomers = async () => {
  try {
    const response = await axiosInstance.get("/customers");
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getCustomerById = async (id) => {
  try {
    const response = await axiosInstance.get(`/customers/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const createCustomer = async (customerData) => {
  try {
    const response = await axiosInstance.post("/customers", customerData);
    // Backend returns { success: true, data: {...} }
    return response.data.data || response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateCustomer = async (id, customerData) => {
  try {
    const response = await axiosInstance.put(`/customers/${id}`, customerData);
    // Backend returns { success: true, data: {...} }
    return response.data.data || response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const deleteCustomer = async (id) => {
  try {
    const response = await axiosInstance.delete(`/customers/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
